import { render, staticRenderFns } from "./radio-input.vue?vue&type=template&id=fbfc8a36&scoped=true"
import script from "./radio-input.vue?vue&type=script&lang=ts"
export * from "./radio-input.vue?vue&type=script&lang=ts"
import style0 from "./radio-input.vue?vue&type=style&index=0&id=fbfc8a36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfc8a36",
  null
  
)

export default component.exports